import { keepPreviousData } from '@tanstack/react-query'
import { uniqBy } from 'lodash'
import { useEffect, useState } from 'react'

import { ClientIdentityDtoCursorPaginatedResponse, useGetAllClientIdentityApis } from '@/gen/publicApi'

export default function useGetAllClientIdentityApisInfinite(clientCode: string) {
    const [cursor, setCursor] = useState<string | undefined>(undefined)
    const [pages, setPages] = useState<ClientIdentityDtoCursorPaginatedResponse['data']>([])
    const [nextCursor, setNextCursor] = useState<string | undefined>(undefined)
    const { data, isLoading, refetch } = useGetAllClientIdentityApis(
        clientCode,
        {
            Cursor: cursor,
        },
        {
            query: {
                placeholderData: keepPreviousData,
                suspense: true,
            },
        },
    )

    useEffect(() => {
        if (!data) {
            return
        }

        setNextCursor(data?.nextCursor || undefined)

        const newData = pages?.concat(data.data || [])
        const newPages = uniqBy(newData, page => page.id)
        setPages(newPages)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    const fetchNextPage = () => {
        if (!nextCursor) {
            return
        }

        setCursor(nextCursor)
    }

    return {
        data: pages,
        isLoading,
        fetchNextPage,
        hasNextPage: nextCursor !== undefined,
        refetch,
    }
}
